import React from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import palette from '../../styles/palette';

const useStyles = makeStyles(() => ({
  button: {
    minWidth: '3.125rem',
    color: palette.snackbarButtons.yellow,
  },

  shine: {
    background: `linear-gradient(to right, ${palette.snackbarButtons.yellow} 0, white 10%, ${palette.snackbarButtons.yellow} 30%)`,
    backgroundPosition: 0,
    animation: '$shineEffect 3s infinite linear',
    animationFillMode: 'forwards',
    fontWeight: 600,
    textDecoration: 'none',
    textShadow: '0 0 10px #fff, 0 0 20px #fff, 0 0 0px #fff',
    letterSpacing: '2px',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    '-webkit-text-size-adjust': 'none',
  },

  '@keyframes shineEffect': {
    '0%': {
      backgroundPosition: 0,
      textShadow: '0 0 10px #fff, 0 0 20px #fff, 0 0 0px #fff',
    },
    '60%': {
      backgroundPosition: '60px',
      textShadow: '0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff',
    },
    '100%': {
      backgroundPosition: '60px',
      textShadow: '0 0 10px #fff, 0 0 20px #fff, 0 0 40px #fff',
    },
  },
}));

const ActionButton = ({ children, onClick }) => {
  const classes = useStyles();

  return (
    <Button
      color="secondary"
      size="small"
      className={classes.button}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default ActionButton;
